import { useTranslation } from 'react-i18next';
import type { TurnstileState } from '../lib/useTurnstile.js';

/** Turnstile konteiners + stāvokļa teksts. Nerenderē neko, ja logrīks ir izslēgts (nav site-key). */
export function TurnstileWidget({ turnstile }: { turnstile: TurnstileState }) {
  const { t } = useTranslation('auth');
  if (!turnstile.enabled) return null;
  return (
    <div className="flex flex-col gap-1">
      <div ref={turnstile.containerRef} />
      {turnstile.status === 'loading' && (
        <p className="text-xs text-slate-500 dark:text-slate-400">{t('turnstile.loading')}</p>
      )}
      {turnstile.status === 'error' && (
        <p className="text-xs text-red-600 dark:text-red-400" role="alert">
          {t('turnstile.unavailable')}
        </p>
      )}
    </div>
  );
}
